var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Glyph",
    viewBox: "0 0 24 24",
    fill: "#1c4b3b",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.14 10.48-1.91.46.75-1.9c.12-.29.37-.52.67-.6.33-.09.67-.02.93.21s.39.55.33.98c-.05.41-.36.76-.77.85zm-2.39-2.31c.33-.56.85-1 1.49-1.17.81-.22 1.68-.03 2.32.52s.95 1.38.85 2.22c-.08.6-.34 1.12-.73 1.52h6.07v-4.25c0-2.07-1.68-3.75-3.75-3.75h-6.25zm-3.89 2.31 1.91.46-.75-1.9c-.12-.29-.37-.52-.67-.6-.09-.03-.19-.04-.28-.04-.24 0-.47.08-.66.25-.26.23-.39.55-.34.89.06.5.37.84.78.94zm-1.55.77c-.38-.38-.64-.88-.71-1.44-.12-.92.2-1.75.83-2.3.64-.55 1.5-.75 2.32-.52.63.18 1.16.61 1.49 1.17v-4.91h-6.25c-2.07 0-3.75 1.68-3.75 3.75v4.25zm3.93 2.56-2.22 2.22c-.15.15-.34.22-.53.22s-.38-.07-.53-.22c-.29-.29-.29-.77 0-1.06l2.22-2.22h-8.93v4.25c0 2.07 1.68 3.75 3.75 3.75h6.25v-6.94zm2.56-1.06 2.22 2.22c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22s-.38-.07-.53-.22l-2.22-2.22v6.94h6.25c2.07 0 3.75-1.68 3.75-3.75v-4.25z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.2c21f8c20549b74e4a67cc070f22725c.svg";
export { ForwardRef as ReactComponent };